import React from "react";
import Heading from "./components/Heading/Heading";
import Search from "./components/Search/Search";
import Body from "./components/Body/Body";

function App() {
  return (
    <>
      <Heading />
      <br />
      <Body />
    </>
  );
}

export default App;
